import {cssStyle, cssStyleResponsive} from '../utils/propsUtils';

const ALIGN_AMP = {
  inherit: 'inherit',
  center: 'center',
  left: 'start',
  right: 'flex-end'
};

/**
 "text": {
    "textColor": "#FFFFFF",
    "fontSize": 15,
    "bold": "normal"
  }
 * */
export const alignCss = ({align, viewport}) => {
  return `
     ${cssStyleResponsive(viewport, 'text-align', align)}
     ${cssStyleResponsive(viewport, 'justify-content', align, ALIGN_AMP)}
  `;
};
export const alignNormalCss = ({align}) => {
  return `
     ${cssStyle('text-align', align)}
     ${cssStyle('justify-content', align, ALIGN_AMP)}
  `;
};

export const alignContentCss = ({text, viewport}) => {
  const {align} = text || {};
  return `
     ${cssStyleResponsive(viewport, 'justify-content', align, ALIGN_AMP)}
  `;
};

